import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

import HistorySlider from "./HistorySlider";

function History() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{ backgroundImage: 'url(./images/thali.jpeg)', backgroundSize: 'cover', backgroundPosition: 'top' }}></div>
      <div class="container" style={{background:'white'}}>
        <div class="row">
          <div class="col-md-12">
            {/* <HistorySlider /> */}
            <div style={{ padding: '60px' }}>
              {/* <h3 className="historyheadeg">{t("history_h1")}</h3> */}

              <h3 className="historyheadeg">History</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                Tali temple is one of the oldest temples in Kozhikode. The temple was built by Swamy Thirumulapad. The founding and prosperity of Kozhikode city is closely linked with the sanctity of this ancient temple. It is believed that the lingam in the sanctum of the Temple was installed towards the end of Dvapara Yuga by Sri. Parasurama. The posture in the sanctum is that of Umamaheswara. Though this divine power existed from time immemorial, the attention of the citizens of Kozhikode was (bestowed on the temple) only by about 1500 years ago. Later on the temple reached its zenith during the rule of the Zamorin of Calicut,(also known as Samoothiri)who had the prestigious title Sailabdheswara. The temple to its present state was built in the 14th century.[3] The temple was almost damaged when Tipu Sultan invaded Kozhikode in the 18th century. Again the shrine was renovated in 1964. Revathi Pattathanam function started at this temple. Eminent people and philosophers came to this function. Bharatha Meemamsa, Prabhakara Meemamsa, Vedanta Meemamsa and Vyakarana were discussed at the functions. During the 15th and 16th centuries, eighteen poets came to this function. This function also takes place at present. Some historians believe the temple was made even before the city was built.
                {/* {t("history_h1_para")} */}
              </p>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                Tali Shiva Temple or Tali Mahakshetram is a Hindu temple dedicated to the deity Shiva, situated in the heart of the Kozhikode city, Kerala. The temple was built in the 14th century by Zamorin of Calicut.[1][2] Tali Kshetram is an ancient temple in the heart of Kozhikode town. Shiva is the presiding deity. The Jyothirlingam in the Sanctum Sanctorum is believed to have been installed by Parasuraman. The temple is one km to the east of Kozhikode railway station. It is surrounded by the Palayam market. This was the family temple of the Zamorins who had ruled Kozhikode. Although the temple is now under Malabar Devaswom, the Zamorin is the managing trustee. The temple is built in traditional Kerala architectural style. The two-storied sanctum-sanctorum is in the shape of a chariot. It is adorned with murals and granite sculptures of Shiva’s retinue. Inside Sree Kovil deities of Tali Ganapathy, Thevarathil Ganapathy and Thrumandhakunnu Bhagavathy are installed. Sree Krishna, Thevarathil Bhagavathy, Ayyappa, Sri Vishnu and Nagam are installed outside Shiva Temple. Sree Valayanad Bhagavati idol is installed inside Sree Krishna Temple. There is a small Narasimha Moorthy temple on the southern side of the Sri Vishnu Temple.
              </p>

              {/* <h3 className="historyheadeg">{t("history_h2")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h2_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h3")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h3_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h4")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h4_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h5")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h5_para")}
              </p>

              <h3 className="historyheadeg">{t("history_h6")}</h3>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_para")}
              </p>
              <ol className="hcontent" style={{ marginLeft: '25px' }}>
                <li>{t("1")}</li>
                <li>{t("2")}</li>
                <li>{t("3")}</li>
              </ol>
              <p className="hcontent" style={{ fontFamily: 'anek malayalam' }}>
                {t("history_h6_2_para")}
              </p> */}

            </div>

          </div>
          

        </div>
      </div>
    </div>
  );
}

export default History;
